import axios from '../request/http.js'
import { handleGetRequestParams } from '../common/js/utils.js'

class Purchase {
  /* 采购列表 */
  static getPurchaseList(options) {
    let url = `/zzd/api/back/purchase/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 采购详情 */
  static getPurchaseDetails(id) {
    let url = `/zzd/api/back/purchase/detail/${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 逐日消耗登记表列表 */
  static getDailyConsumptionList(options) {
    let url = `/zzd/api/back/purchase/list/daily/consumption/registration?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 一周伙食采购报表 */
  static getFoodAccountList(options) {
    let url = `/zzd/api/back/purchase/supplier/statements?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 采购代发票列表 */
  static getSubstituteList(options) {
    let url = `/zzd/api/back/purchase/invoice/for/food/purchase?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 采购列表作废 */
  static getNullifyPurchase(id) {
    let url = `/zzd/api/back/purchase/cancel/${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 采购列表恢复作废 */
  static getRecoveryPurchase(id) {
    let url = `/zzd/api/back/purchase/cancel/return/${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 生成费用单 */
  static postCreateExpense(data) {
    const url = `/zzd/api/back/order/bill/add/three`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Purchase